import React from "react";
import _ from "underscore";

/**
 * Add props to a component. Useful for changing default props of an imported component.
 */
export function withProps<TProps, TState>(WrappedComponent: React.ComponentClass<TProps>, props: Partial<TProps>): React.ComponentClass<TProps & TProps> {
  return class extends React.Component<TProps & TProps, TState> {
    public render() {
      const { children, ...rest } = _.extend({}, this.props, props);
      return <WrappedComponent {...rest}>{children}</WrappedComponent>;
    }
  };
}

/**
 * Type guard for whether the provided object is a React component.
 */
// tslint:disable-next-line: no-string-literal
export const isElement = (x: any): x is JSX.Element => x["props"] != null;
